import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/g6-pro-turret.png";
import type { Product } from "../../types";
import { physicalSecurityDomeTurret } from "../product-list-groups/physicalSecurityDomeTurret";
import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories";

export const g6ProTurret: Product = {
  id: "g6ProTurret",
  productTitle: "G6 Pro Turret",
  description: "g6ProTurret.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.CamerasNVRs}/uvc-g6-pro-turret`,
  ],
  storePathParts: {
    productSlug: "uvc-g6-pro-turret",
    category: "cameras-dome-turret",
  },
  productListGroup: physicalSecurityDomeTurret,
  image: { src: image, width: 200, height: 140 },
  isNew: true,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø117.2 × 116.5 mm\n(Ø4.61 × 4.59")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.2" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: { type: "translation", value: "g6ProTurret.fieldOfView" },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "40 m (131 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: "deployment",
      value: { type: "string", value: "PoE+" },
    },
  ],
};
